import { render, staticRenderFns } from "./WorkspaceFabricPlatbandTool.vue?vue&type=template&id=1eb8da8c&scoped=true&"
import script from "./WorkspaceFabricPlatbandTool.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricPlatbandTool.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricPlatbandTool.vue?vue&type=style&index=0&id=1eb8da8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8da8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb8da8c')) {
      api.createRecord('1eb8da8c', component.options)
    } else {
      api.reload('1eb8da8c', component.options)
    }
    module.hot.accept("./WorkspaceFabricPlatbandTool.vue?vue&type=template&id=1eb8da8c&scoped=true&", function () {
      api.rerender('1eb8da8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricPlatbandTool.vue"
export default component.exports